<div class="user-login-container">
  <form [formGroup]="forgotEmailForm" (submit)="onSubmitForgotEmailForm(forgotEmailForm)">
      <h3>Florist</h3>
      <h4>Forgot Password</h4>
      <div class="row white-box">
          <div class="col-md-12">
              <label>Email</label>
              <mat-form-field appearance="outline" floatLabel="never">
                  <input type="text" formControlName="email" matInput placeholder="Enter Email" required />
                  <mat-error *ngIf="requiredValidation(formControls['email'])">Email is required</mat-error>
                  <mat-error *ngIf="patternValidation(formControls['email'])">Enter valid email address</mat-error>
              </mat-form-field>
          </div>

          <div class="col-md-12 MB-10 text-center">
              <button type="submit" [disabled]="!forgotEmailForm.valid" mat-raised-button class="black-btn" color="primary">
                  Send Email
              </button>
          </div>
      </div>
  </form>
</div>
